import { AsyncPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import {
  OnyxDropdownComponent,
  OnyxSectionComponent,
  OnyxUploadComponent,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../common/enums/dictionary-code';
import { DictionariesService } from '../../../../common/services/dictionaries.service';

type FleetCo2EmissionsFormGroup = ReturnType<
  (typeof FleetCo2EmissionsFormComponent)['buildForm']
>;

@Component({
  selector: 'app-fleet-co2-emissions-form',
  imports: [
    OnyxSectionComponent,
    ReactiveFormsModule,
    OnyxDropdownComponent,
    AsyncPipe,
    OnyxUploadComponent,
  ],
  templateUrl: './fleet-co2-emissions-form.component.html',
  styleUrl: './fleet-co2-emissions-form.component.scss',
})
export class FleetCo2EmissionsFormComponent {
  private readonly dictionariesService = inject(DictionariesService);

  public readonly form = input.required<FleetCo2EmissionsFormGroup>();

  protected readonly I18N = 'fleet.fleetForm.co2Emissions';

  protected emissionStandards$ = this.dictionariesService.getDictionary(
    DictionaryCode.EMISSION_STANDARD,
  );

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      emissionStandard: fb.control<string | null>('euro-6', [
        Validators.required,
      ]),
      emissionCertificate: fb.control<string | null>(null),
    });
  }
}
